import React from "react";
import "../../../css/DesignSystem/Buttons/LogoutButton.css";
import { ReactComponent as LogoutIcon } from "../../../assets/icons/logout-icon.svg";
const LogoutButton = ({ title, onClick }) => {
  return (
    <div className="LogoutButton-Container" onClick={onClick}>
      <div className="Button-Text">{title}</div>
      <LogoutIcon />
    </div>
  );
};
export default LogoutButton;
